module.exports = __webpack_public_path__ + "img/project4.8cc86400.jpg";